import { FileTextOutlined, BarChartOutlined, AimOutlined, CalendarOutlined, DollarOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { HomeStyledCardWrapper } from './AlertAndNotificationCard';

const planningItems = [
    {
        icon: AimOutlined,
        title: 'Annual Operating plan (AOP)',
        path: '/planner',
    },
    {
        icon: CalendarOutlined,
        title: 'Sales & Operations plan (S&OP)',
        path: '',
    },
    {
        icon: DollarOutlined,
        title: 'Value tracker',
        path: '/lt-report',
    },
];

export const VibrantPlanningCenter = () => {
    const navigate = useNavigate();

    return (
        <HomeStyledCardWrapper bordered={false}>
            <h3 className="text-lg font-semibold text-gray-800 mb-6 m-0">
                AI Decision Hub <span className="text-sm text-gray-500 font-normal">— Plan, align, approve</span>
            </h3>
            <div className="flex flex-col gap-3">
                {planningItems.map((item, index) => {
                    const Icon = item.icon;
                    return (
                        <button
                            key={index}
                            onClick={() => item.path && navigate(item.path)}
                            className="flex w-full items-center gap-3 rounded-lg p-3 text-left transition-colors hover:bg-gray-100 active:bg-gray-200 cursor-pointer border-0 bg-transparent"
                        >
                            <div
                                className="flex h-10 w-10 items-center justify-center rounded-md shrink-0"
                                style={{
                                    backgroundColor: 'rgba(168, 85, 247, 0.1)',
                                }}
                            >
                                <Icon className="text-lg" style={{ color: 'hsl(262 60% 50%)' }} />
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className="font-medium text-sm text-gray-900 m-0">{item.title}</p>
                            </div>
                        </button>
                    );
                })}
            </div>
        </HomeStyledCardWrapper>
    );
};
